export function isCorporate(clientName: string): boolean {
  return [
    'Netbanki fyrirtækja',
    'Corporate online banking',
    'Firmowy bank internetowy',
  ].includes(clientName);
}
